import { render, staticRenderFns } from "./cms-page-renderer.vue?vue&type=template&id=72ab236b&scoped=true"
import script from "./cms-page-renderer.vue?vue&type=script&lang=js"
export * from "./cms-page-renderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ab236b",
  null
  
)

export default component.exports